import { createTheme } from '@one-thd/sui-atomic-components';

const CyberMonday2026PrimaryTwo = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

CyberMonday2026PrimaryTwo.palette['--sui-palette-background-primary'] = '101 216 232';

export { CyberMonday2026PrimaryTwo };